import { useEffect } from 'react';
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./lib/auth";
import { SiteSettingsProvider } from "./lib/siteSettings";
import InquiryModal from "./components/feature/InquiryModal";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <SiteSettingsProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <ScrollToTop />
            <AppRoutes />
          </BrowserRouter>
          <InquiryModal />
        </SiteSettingsProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;